import MoreVertIcon from '@mui/icons-material/MoreVert';
import {MouseEvent} from 'react';
import {Stack, Tooltip} from '@mui/material';

import {formatNotificationDate} from '../../helpers/format-notification-date';
import {AppNotification} from '../../types/notifications.types';
import {
  NewLabel,
  NotificationContent,
  NotificationDate,
  NotificationMenuButton,
  NotificationMessage,
  NotificationRow,
  NotificationText,
  NotificationTitle,
} from '../notifications.styles';

interface NotificationListItemProps {
  notification: AppNotification;
  onOpenActions: (event: MouseEvent<HTMLElement>, id: string) => void;
  onOpenDetails: (id: string) => void;
}

export const NotificationListItem = ({notification, onOpenActions, onOpenDetails}: NotificationListItemProps) => {
  return (
    <NotificationRow direction="row" alignItems="flex-start" onClick={() => onOpenDetails(notification.id)}>
      <NotificationContent>
        <NotificationText>
          <Stack direction="row" alignItems="center" gap="8px">
            <NotificationTitle noWrap>{notification.title}</NotificationTitle>
            {notification.markType === 'NEW' && <NewLabel>НОВОЕ</NewLabel>}
          </Stack>
          <Tooltip title={notification.message} PopperProps={{disablePortal: true}} enterTouchDelay={100}>
            <NotificationMessage noWrap>{notification.message}</NotificationMessage>
          </Tooltip>
        </NotificationText>
        <NotificationDate>{formatNotificationDate(notification.createDate)}</NotificationDate>
      </NotificationContent>

      <NotificationMenuButton
        onClick={(event) => {
          event.stopPropagation();
          onOpenActions(event, notification.id);
        }}
        aria-label="Действия с уведомлением"
      >
        <MoreVertIcon />
      </NotificationMenuButton>
    </NotificationRow>
  );
};
